import { IPaginationData } from "@faire/web-api/indigofair/data/IPaginationData";
import { IProductFirstCatNavRequest } from "@faire/web-api/indigofair/data/IProductFirstCatNavRequest";

import { useCategoryPageFilterKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useCategoryPageQueryParams } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { useRequestReferrer } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import { useLoggedOutCategoryPageRequestPageSize } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPageRequestPageSize";

export const useLoggedOutCategoryPageCatNavRequest = () => {
  const navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
  const filter_keys = useCategoryPageFilterKeys();
  const referrer = useRequestReferrer();
  const { oneIndexedPageNumber } = useCategoryPageQueryParams();
  const page_size = useLoggedOutCategoryPageRequestPageSize();
  const paginationPayload = IPaginationData.build({
    page_number: oneIndexedPageNumber,
    page_size,
  });
  return IProductFirstCatNavRequest.build({
    navigation_path: navigationPath,
    filter_keys,
    pagination_data: paginationPayload,
    container_name: "marketplace_maker_grid",
    referrer,
  });
};
